import { useMediaQuery, useTheme } from '@mui/material';
import useMsalUser from '@shared/hooks/useMsalUser';
import appLogger from '@shared/logging/appLogger';
import type {} from '@shared/utilities/horizon/components';
import { useEffect } from 'react';

import styles from './UserNotActive.module.scss';

const SpotIcon = () => (
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M48 74.4805C50.2091 74.4805 52 72.6896 52 70.4805C52 68.2713 50.2091 66.4805 48 66.4805C45.7909 66.4805 44 68.2713 44 70.4805C44 72.6896 45.7909 74.4805 48 74.4805Z"
            fill="#005AB8"
        />
        <path
            d="M45.8101 58.0404L44.7501 33.6304C44.7201 29.1504 51.2801 29.1404 51.2501 33.6304L50.1901 58.0404C50.0101 60.8104 45.9901 60.8104 45.8101 58.0404Z"
            fill="#005AB8"
        />
        <path
            d="M79.87 86.2295H16.13C12.46 86.2295 9.16996 84.3395 7.31996 81.1695C5.46996 77.9995 5.45996 74.1995 7.26996 71.0095L39.14 14.9295C40.97 11.6995 44.29 9.76953 48 9.76953C51.71 9.76953 55.02 11.6995 56.86 14.9295L88.73 70.9995C90.54 74.1895 90.52 77.9895 88.68 81.1595C86.83 84.3295 83.54 86.2195 79.87 86.2195V86.2295ZM48 14.1495C45.88 14.1495 44 15.2495 42.95 17.0895L11.08 73.1595C10.05 74.9795 10.06 77.1395 11.11 78.9495C12.16 80.7595 14.04 81.8395 16.13 81.8395H79.86C81.95 81.8395 83.8299 80.7595 84.88 78.9495C85.93 77.1395 85.94 74.9795 84.91 73.1595L53.04 17.0895C51.99 15.2495 50.11 14.1495 47.99 14.1495H48Z"
            fill="#2A343D"
        />
    </svg>
);

export default function UserNotActive() {
    const theme = useTheme();
    const { getUser, isAuthenticated, redirectToLogin } = useMsalUser();
    const smallScreenMatch = useMediaQuery(theme.breakpoints.down('sm'));
    const headingSize = smallScreenMatch ? 'small' : 'medium';
    const lineHeight = smallScreenMatch ? 'xsmall' : 'base';

    useEffect(
        () =>
            appLogger.logPageView({
                name: 'User Not Active - AccountAccessProblem',
                refUri: `${window.location.href}`,
            }),
        []
    );

    useEffect(() => {
        if (isAuthenticated && !getUser()) {
            redirectToLogin();
        }
    }, [getUser, isAuthenticated]);

    return (
        <div className={styles['user-not-active']}>
            <hzn-stack space="base" align-x="center" align-y="center">
                <SpotIcon />
                <hzn-heading as="h1" align="center" size={headingSize} line-height={lineHeight}>
                    Account access problem
                </hzn-heading>
                <div className={styles['page-body']}>
                    <hzn-text
                        variant="text"
                        size="base"
                        tone="body"
                        weight="base"
                        align="center"
                        as="p"
                        line-height="base">
                        We are unable to verify your Carmax Auctions user account. <br />
                        Try again in a bit or contact{' '}
                        <hzn-text-link href={process.env.AUCTIONS_HOMEPAGE_URL + '/contact-us'}>
                            Auction Services
                        </hzn-text-link>{' '}
                        if the issue continues.
                    </hzn-text>
                </div>
            </hzn-stack>
        </div>
    );
}
